export const permissionsQueryKeys = {
  permissionsUsers: ['permissions', 'users'] as const,
  permissionsUser: (userId: string) => ['permissions', 'users', userId] as const,
  permissionsUserGroups: ['permissions', 'user-groups'] as const,
  permissionsUserGroup: (userGroupId: string) =>
    ['permissions', 'user-groups', userGroupId] as const,
  permissionsAssigned: (
    params: {
      prm_user_id?: string
      user_group_id?: string
      target_resource_id?: string
      target_resource_type_id?: string
      result_resource_type_id?: string
    } = {}
  ) => ['permissions', 'assigned', params] as const,
  permissionsAssignedAll: ['permissions', 'assigned'] as const,
  resourcePermissionEditor: (resourceTypeName: string, resourceId: string) =>
    ['permissions', 'resource-editor', resourceTypeName, resourceId] as const,
  resourcePermissionEditors: ['permissions', 'resource-editor'] as const,
  permissionsResolved: (params: { prm_user_id?: string; target_resource_id?: string } = {}) =>
    ['permissions', 'resolved', params] as const,
  permissionsTables: ['permissions', 'tables'] as const,
  permissionsTableSchema: (tableId: string) =>
    ['permissions', 'tables', tableId, 'schema'] as const,
  permissionsModuleCatalog: ['permissions', 'modules', 'catalog'] as const,
  permissionsModules: ['permissions', 'modules'] as const,
  permissionsActions: ['permissions', 'actions'] as const,
  permissionsImplicationRules: ['permissions', 'implication-rules'] as const,
  permissionsResourceTypes: ['permissions', 'resource-types'] as const,
}
